var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.domainRoot)?_c('files',{ref:"File",attrs:{"show-deleted":_vm.showDeleted,"folder-id":_vm.domainRoot.id,"read-only":_vm.readOnly,"allow-upload":_vm.allowUpload}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }